import React, { useContext } from "react";
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import SessionContext from "SessionContext";
import { useGlobalState } from "hooks/useGlobalState";
import { MinimalTemplate } from "templates/templates";
import { useHistory } from "react-router-dom";

const LandingPage = () => {
    const session = useContext(SessionContext);
    const access = session.appState.userCan;
    const appState = session.appState;
    const { companyHasExternalDestinations } = useGlobalState();

    const explorer_modules = session.crossfilterStore.EXPLORER_MODULES;

    const handleSendEmail = () => {
        window.location.href='mailto:audienceMaker@speedeondata.com';
    };

    // check if user has 'settings' permission
    let user_has_settings_permissions = access('settings');

    // check if the company has reseller active 'allow_sub_companies'
    let company_is_reseller = appState.activeCompany.allow_sub_companies;

    const show_settings_link = user_has_settings_permissions && (company_is_reseller || companyHasExternalDestinations);

    return (
        <div className="landing">
            <img src={window.skin.header_logo} alt={window.skin.site_name} className='logo mb-3' />

            <div className="mt-3 explorer-header">
                <div className="explorer-title"><i className="fa fa-map"></i> EXPLORER</div>
                <div className="explorer-desc">
                    Create Audiences and Insights with Interactive Charts and Maps.
                </div>
            </div>

            <div className="landing-nav-row mt-1">
                {explorer_modules.map((option) => 
                    <ExplorerOptions key={option} option={option} />
                )}
            </div>

            <div className="landing-nav-row">
                {access('audience_view') &&
                    <div className="links-row">
                        <Link to="/audiences">
                            <Button className="btn-primary outline-pink" to="/audiences"><i className="fa fa-users"></i>My Audiences</Button>
                        </Link>
                        <div className="link-desc">
                          Your Previously Saved Audiences
                        </div>
                    </div>}
            </div>

            <div className="landing-nav-row">
                {access('location_view') &&
                    <div className="links-row three">
                        <Link to="/locations">
                            <Button className="btn-primary outline-blue" to="/locations"><i className="fa fa-location-dot"></i>Locations</Button>
                        </Link>
                        <div className="link-desc">
                          Upload New Locations and Browse and Map Previously Uploaded Locations
                        </div>
                    </div>}
                {access('upload_view') &&
                    <div className="links-row three">
                        <Link to="/uploads">
                            <Button className="btn-primary outline-blue" to="/uploads"><i className="fa fa-cloud-arrow-up"></i>Uploads</Button>
                        </Link>
                        <div className="link-desc">
                          Upload New and Browse Previously Uploaded Customers, Contacts, and External Prospects
                        </div>
                    </div>}
                {access('order_view') &&
                    <div className="links-row three">
                        <Link to="/orders">
                            <Button className="btn-primary outline-blue" to="/orders"><i className="fa fa-box-archive"></i>Orders</Button>
                        </Link>
                        <div className="link-desc">
                          Your Previously Placed Orders
                        </div>
                    </div>}
            </div>

            <div className="landing-nav-row">
                {access('model_view') &&
                    <div className="links-row three">
                        <Link to="/models">
                            <Button className="btn-primary outline-blue" to="/models"><i className="fa fa-users-viewfinder"></i>Models</Button>
                        </Link>
                        <div className="link-desc">
                          Your Previously Built Models
                        </div>
                    </div>}
                {access('audience_view') &&
                    <div className="links-row three">
                        <Link to="/compare-list">
                            <Button className="btn-primary outline-blue" to="/compare-list"><i className="fa fa-chart-line"></i>Compare</Button>
                        </Link>
                        <div className="link-desc">
                          Create New Reports Comparing Audiences and Browse Previously Built Reports
                        </div>
                    </div>}
            </div>

            <div className="landing-nav-row">
                {show_settings_link &&
                    <div className="links-row three">
                        <Link to="/company-settings">
                            <Button className="btn-primary outline-blue"><i className="fa fa-sliders"></i>
                              Settings
                            </Button>
                        </Link>
                        <div className="link-desc">
                          Company Settings and Options
                        </div>
                    </div>}
                {access('administration') &&
                    <div className="links-row three">
                        <Link to="/admin">
                            <Button className="btn-primary outline-blue"><i className="fa fa-gear"></i>Admin</Button>
                        </Link>
                        <div className="link-desc">
                          Administration Settings and Options
                        </div>
                    </div>}
            </div>

            <div className="landing-nav-row">
                <div className="links-row">
                    <Button className="purple-btn" size="sm" href={`${window.support_url}`} target='_blank'>
                        <i className="fa fa-compass"></i>Tutorials & Guides
                    </Button>
                    <div className="link-desc">
                      Tutorials, Guides, and Support Articles for Help Navigating and Utilizing AudienceMaker
                    </div>
                </div>
                <div className="links-row">
                    <Button className="support-btn" size="sm" onClick={handleSendEmail}>
                        <i className="fa fa-circle-question"></i>Support
                    </Button>
                    <div className="link-desc">
                      Contact our team for questions, concerns, and additional support
                    </div>
                </div>
            </div>
        </div>
    );
};

// Attach template property for compatibility
LandingPage.template = MinimalTemplate;

export default LandingPage;

const options_info = {
    consumers: {
        label: "consumers",
        icon: "fa-solid fa-globe",
        description: "Create Audiences Using Consumers Data",
    },
    movers: {
        label: "movers",
        icon: "fa-solid fa-truck",
        description: "Create Audiences using New Movers and Premovers",
    },
    life_events: {
        label: "life events",
        icon: "fa-regular fa-calendar-days",
        description: "Create Audiences using Life Events relating to marital status changes and new babies",
    }
}

const ExplorerOptions = ({ option }) => {
    const session = useContext(SessionContext);
    const history = useHistory();
    const access = session.appState.userCan;

    const handleNavigation = (path) => {
        if(session.crossfilterStore.explorerModule !== path ) {
          session.crossfilterStore.restoreFromAudience("clear_all");
          session.crossfilterStore.setExplorerModule(path);
          history.push('/explorer');
        } else {
          history.push('/explorer');
        }
    }

    // Add the return statement and use the option prop
    return access('has_explorer_view') ? (
        <div className="links-row">
            <Link to=""
                onClick={(e) => {
                    e.preventDefault();
                    handleNavigation(option); // Use option.path from props
                }}
            >
                <Button className="btn-primary outline-pink">
                    <i className={options_info[option].icon}></i> {options_info[option].label}
                </Button>
            </Link>
            <div className="link-desc">
                {options_info[option].description}
            </div>
        </div>
    ) : null;
};